import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PayrollHeroAnimatedText from './PayrollHeroAnimatedText';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import { getBreadcrumbSchema } from '../navigation/breadcrumbSchema';
import SEO from '../seo/SEO';
import './PayrollSoftware.css';

const PayrollSoftware = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath =
    servicesIndexView === 'payroll' ||
    location.pathname.startsWith('/services/payroll/')
      ? '/services/payroll'
      : servicesIndexView
        ? '/services'
        : '/';

  const breadcrumbItems = buildServiceBreadcrumbs('payroll', 'Payroll Software');
  const breadcrumbSchema = getBreadcrumbSchema(breadcrumbItems);

  return (
    <div className="standard-page-wrapper">
      <SEO schema={breadcrumbSchema} />
      <div className="standard-page-container">
        <Breadcrumbs items={breadcrumbItems} />

        <div className="standard-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="standard-page-hero">
          <PayrollHeroAnimatedText
            as="h1"
            text="Payroll Software Services"
            className="payroll-hero-title"
            variant="from-top"
            threshold={0}
            rootMargin="0px"
            step={54}
          />
          <p>
            BlackRoth delivers modern Payroll Software solutions that automate
            salary processing, ensure statutory compliance, and provide
            secure, scalable payroll management for growing businesses.
          </p>
        </div>

        <section className="standard-page-section">
          <h2>Overview</h2>
          <p>
            Payroll Software is essential for organizations seeking accuracy,
            efficiency, and compliance. BlackRoth builds and implements
            payroll software platforms that streamline payroll workflows,
            minimize manual effort, and provide real-time visibility.
          </p>
        </section>

        <section className="standard-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our payroll software solutions are designed to handle complex
            payroll structures, multi-location operations, and regulatory
            requirements with high reliability and security.
          </p>
        </section>

        <section className="standard-page-section">
          <h2>Payroll Software Services We Offer</h2>
          <ul className="standard-service-list">
            <li>Custom Payroll Software Development</li>
            <li>Payroll Automation & Workflow Management</li>
            <li>Salary Processing & Payslip Generation</li>
            <li>Tax & Statutory Compliance Automation</li>
            <li>Attendance & Leave Management Integration</li>
            <li>Employee Self-Service (ESS) Portals</li>
            <li>Payroll Reports & Analytics</li>
            <li>Software Maintenance & Enhancements</li>
          </ul>
        </section>

        <section className="standard-page-section">
          <h2>Business Value</h2>
          <p>
            BlackRoth's Payroll Software Services reduce operational costs,
            improve payroll accuracy, enhance compliance, and increase
            employee trust through transparent and timely payroll execution.
          </p>
        </section>

        <section className="standard-page-section">
          <h2>Technology & Integration</h2>
          <p>
            Our payroll software platforms integrate with HRMS, accounting
            systems, banking APIs, and attendance platforms using secure,
            cloud-based architectures and modern APIs.
          </p>
        </section>

        <section className="standard-page-section">
          <h2>Security & Compliance</h2>
          <p>
            BlackRoth enforces strong security measures including encryption,
            role-based access control, audit trails, and compliance with
            statutory and data protection regulations.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PayrollSoftware;
